import { PopupUtils } from './popup-utils';

export type PopupActions = {
    loading: (value: boolean) => void;
    close: () => void;
    startAction: () => void;
    endAction: () => void;
};

export type PopupAlertProps = {
    title?: React.ReactNode;
    message?: React.ReactNode;
    children?: React.ReactNode;
    icon?: 'success' | 'warning' | 'error' | React.ReactNode;
    type?: 'success' | 'warning' | 'error';
    maxWidth?: string;
    'data-test-id'?: string;
    showClose?: boolean;
    isClickOutSideClose?: boolean;
    buttons?: {
        'data-test-id'?: string;
        label: string;
        variant?: 'primary' | 'second' | 'danger' | 'info';
        className?: string;
        action?: (data: PopupActions) => Promise<void> | void;
    }[];
    classNames?: { title?: string; message?: string; buttons?: string };
};

function PopupAlert(props: PopupAlertProps) {
    return PopupUtils.open(props);
}

export default PopupAlert;
